module.exports = __webpack_public_path__ + "static/media/_MIC2523.thumbnail.895c45cb.png";